import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { formatDateCharts } from "@oldDashboard/legacyUtils";
import { Coordinates } from "@oldDashboard/legacyModels/coordinates.model";
import { ConstituentLevelConversion } from "@oldDashboard/legacyModels/constituentLevelConversion.model";
import { ChartName } from "@oldDashboard/legacyModels/chart.model";
import { setConstituentsConversionsAction } from "@oldDashboard/legacyActions/dashboardClient";

interface LaunchTileProps { affiliateSelected: String, launchSelected: String, searching: boolean }
const useConstituentConversions = (props:LaunchTileProps) => {
    const [chartData, setChartData] = useState<ChartName>();
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        fetchConstituentLevelConversion();
    }, [props.searching, props.launchSelected]);
    
   
    const buildChartData = (constituentConversionData: ConstituentLevelConversion[]) : ChartName =>  {
        
        return  {
            series: 
            constituentConversionData.map(({name, data} : {name: string, data:Coordinates[]}) =>   {
                    return {
                        data: data.map(x=>Number(x.y)),
                        name:name,
                        "type": "line",
                    }
          }
        ),
            options: {
                chart: {
                    height: 320,
                    type: 'line',
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        mounted: (chart:any) => {
                            chart.windowResizeHandler();
                        }
                    },
                },
                colors: ['#845adf', '#23b7e5', '#f5b849'],
                dataLabels: {
                    enabled: true,
                    
                },
                stroke: {
                    curve: 'smooth'
                },

                grid: {
                    borderColor: '#f2f5f7',
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: constituentConversionData.map(({data} : {data : Coordinates[]}) => {return data.map(x=>x.x)})[0],
                    labels: {
                        show: true,
                        style: {
                            colors: "#8c9097",
                            fontSize: '11px',
                            fontWeight: 600,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                        formatter: function(value: string) {
                            if(value){
                                return formatDateCharts(value);
                            }
                     }
                    },
                },
                yaxis: {
                    labels: {
                        show: true,
                        style: {
                            colors: "#8c9097",
                            fontSize: '11px',
                            fontWeight: 600,
                            cssClass: 'apexcharts-yaxis-label',
                        },
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -25,
                    offsetX: -5
                }
            }
        };
    }

    const fetchConstituentLevelConversion = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getConstituentLevelConversion(props.launchSelected);
            if (response) {
                setConstituentsConversionsAction(response);
                const data = buildChartData(response.series_data);
                setChartData(data);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    return { isLoading, chartData, fetchConstituentLevelConversion}
}

export default useConstituentConversions;